import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Mail, Phone, MessageSquare, MapPin, Instagram } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. We'll reply shortly.");
      setForm({ name: "", email: "", message: "" });
    } catch { toast.error("Couldn't send — please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="contact-page" className="max-w-[1200px] mx-auto px-6 lg:px-12 py-20">
      <div className="overline text-[#C5A059]">Contact</div>
      <h1 className="serif text-5xl lg:text-7xl mt-3">Tell us everything.</h1>

      <div className="grid lg:grid-cols-2 gap-16 mt-16">
        <form onSubmit={submit} className="space-y-8">
          <div>
            <div className="fld-label">Name</div>
            <input data-testid="contact-name-input" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="fld mt-2" />
          </div>
          <div>
            <div className="fld-label">Email</div>
            <input data-testid="contact-email-input" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="fld mt-2" />
          </div>
          <div>
            <div className="fld-label">Message</div>
            <textarea data-testid="contact-message-input" required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="fld mt-2 resize-none" />
          </div>
          <button data-testid="contact-submit" disabled={loading} className="btn-primary">{loading ? "Sending…" : "Send message"}</button>
        </form>

        <div className="lg:pl-12 space-y-8">
          <div className="flex gap-4">
            <Mail size={20} strokeWidth={1.2} className="text-[#C5A059] mt-1" />
            <div><div className="overline">Email</div><div className="serif text-xl mt-1">hello@atelier-noir.com</div></div>
          </div>
          <div className="flex gap-4">
            <Phone size={20} strokeWidth={1.2} className="text-[#C5A059] mt-1" />
            <div><div className="overline">Phone</div><a href="tel:+971507334979" className="serif text-xl mt-1 block hover:text-[#C5A059]" data-testid="contact-phone-link">+971 50 733 4979</a></div>
          </div>
          <div className="flex gap-4">
            <MessageSquare size={20} strokeWidth={1.2} className="text-[#C5A059] mt-1" />
            <div>
              <div className="overline">WhatsApp</div>
              <a href="https://wa.me/971507334979" target="_blank" rel="noopener noreferrer" data-testid="whatsapp-link" className="serif text-xl mt-1 hover:text-[#C5A059] block">Chat with us</a>
            </div>
          </div>
          <div className="flex gap-4">
            <Instagram size={20} strokeWidth={1.2} className="text-[#C5A059] mt-1" />
            <div>
              <div className="overline">Instagram</div>
              <a href="https://instagram.com/mohwaheeb" target="_blank" rel="noopener noreferrer" data-testid="contact-instagram-link" className="serif text-xl mt-1 hover:text-[#C5A059] block">@mohwaheeb</a>
            </div>
          </div>
          <div className="flex gap-4">
            <MapPin size={20} strokeWidth={1.2} className="text-[#C5A059] mt-1" />
            <div><div className="overline">Atelier</div><div className="serif text-xl mt-1">12 rue de Sévigné, Paris</div></div>
          </div>

          <div className="aspect-[4/3] bg-[#EFEFE8] mt-10 overflow-hidden">
            <img src="https://images.unsplash.com/photo-1502602898657-3e91760cbb34" alt="Paris store location" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
}
